import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { aboutData } from '../mock';

const About = () => {
  const navigate = useNavigate();

  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-blue-500 to-cyan-400 rounded-2xl transform rotate-3"></div>
              <img
                src={aboutData.image}
                alt="Averon Team"
                className="relative rounded-2xl shadow-2xl w-full h-auto object-cover transform hover:scale-105 transition-transform duration-300"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {aboutData.title}
            </h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              {aboutData.shortDescription}
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              {aboutData.additionalDescription}
            </p>
            <Button
              size="lg"
              className="bg-blue-600 hover:bg-blue-700 text-white group"
              onClick={() => navigate('/about')}
            >
              Daha ətraflı
              <ArrowRight className="ml-2 group-hover:translate-x-1 transition-transform duration-200" size={20} />
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
